import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { PlacesLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import PlaceQuery from 'queries/place/show';
import InspectionSubjectsContainer from 'components/inspection_subject/index_container';
import InspectionsContainer from 'components/inspection/index_container';
import ShowItem from 'components/place/show_item';
import Loader from 'components/loader';
import BreadcrumbContainer from 'components/breadcrumb_container';
import TabsContainer from 'components/tabs_container';
import Container from 'components/layout/container';
import { WhiteCard } from 'components/styles_components/card';

const Place = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const setError = useError();
  const {
    data = {
      space: {
        overInspectionsLimit: false,
        adminRole: true,

      },
      place: {
        overdueInspections: [],
        incomingInspections: [],
      },
    },
    loading,
    error,
    refetch,
  } = useQuery(PlaceQuery, {
    variables: { id },
    onError: () => {
      setError('error.place.show');
      navigate(PlacesLink());
    },
  });
  if (loading || error) {
    return <Loader />;
  }

  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbLink to={PlacesLink()}>
          <FormattedMessage id="breadcrumb.place.index" />
        </BreadCrumbLink>
        <BreadCrumbTypography>{data.place.name}</BreadCrumbTypography>
      </BreadcrumbContainer>
      <ShowItem place={data.place} space={data.space} refetch={refetch} />
      <WhiteCard>
        <TabsContainer
          tabs={[
            { label: <FormattedMessage id="inspection.count" />, visible: true },
            { label: <FormattedMessage id="inspection_subject.count" />, visible: true },
          ]}
          content={[
            <PaginateProvider key="place_inspections_content">
              <InspectionsContainer
                overInspectionsLimit={data.space.overInspectionsLimit}
                adminRole={data.space.adminRole}
                placeId={id}
              />
            </PaginateProvider>,
            <PaginateProvider key="inspection_subjects_content">
              <InspectionSubjectsContainer
                fromParent={true}
                adminRole={data.space.adminRole}
                overInspectionSubjectsLimit={data.space.overInspectionSubjectsLimit}
                placeId={id}
              />
            </PaginateProvider>,
          ].filter(Boolean)}
        />
      </WhiteCard>
    </Container>
  );
};

export default Place;
